export default __webpack_public_path__ + "static/media/center-img-desktop.c7c43018.jpg";